'use client';

import * as React from 'react';
import { useCookieConsent } from 'app/root/[isEU]/_components/cookie-consent';

type ChatWidgetProps = {
  isEU: boolean;
};

export function ChatWidget(props: ChatWidgetProps): JSX.Element {
  const { isAccepted } = useCookieConsent();
  React.useEffect(() => {
    if (props.isEU && !isAccepted) {
      return;
    }

    const id = setTimeout(initChatwoot, 5_000);
    return () => {
      clearTimeout(id);
    };
  }, [props.isEU, isAccepted]);

  return <></>;
}

export function initChatwoot() {
  const BASE_URL = 'https://app.chatwoot.com';
  const script = document.createElement('script') as HTMLScriptElement;
  const firstScript = document.getElementsByTagName(
    'script',
  )[0] as HTMLScriptElement;
  script.src = BASE_URL + '/packs/js/sdk.js';
  script.async = true;
  firstScript.parentNode?.insertBefore(script, firstScript);
  script.onload = function () {
    window.chatwootSDK.run({
      websiteToken: 'V5VYpmYq9vYcNib9ZEk1vrz4',
      baseUrl: BASE_URL,
    });
  };
}
